// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, SpeedDial, SpeedDialIcon, SpeedDialAction, Tab, Tabs, Typography, } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// TODO: Import MUI icon
import { MenuBook } from '@mui/icons-material';

// TODO: Import context
import { Context } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import Slide from '../Slide_LT.jpg';

import BoxSubPage from '../../Common/BoxSubPage';
import BoxImage from '../../Common/BoxImage';
import DialogVideo from '../../Common/DialogVideo';
import { BoxGridColumnsContainer } from '../../Common/BoxGridColumns';

const EnglishEducation = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component EnglishEducation Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const actions = ['English Morning Assembly', 'Halloween', 'Themed Activities', 'Show and Tell',];
    const [value, setValue] = React.useState(actions[0]);
    const [open, setOpen] = React.useState(false);

    // TODO: Define event
    const theme = useTheme();

    const handleChange = (event, newValue) => { setValue(newValue) };

    React.useEffect(() => { window.scrollTo(0, 0); }, [value]);
    React.useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.innerHeight + window.scrollY;
            const documentHeight = document.documentElement.scrollHeight;

            if (documentHeight - scrollPosition < 200) {
                setOpen(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // TODO: Return component
    return (
        <BoxSubPage
            id="EnglishEducation"
            image={Slide}
            title={Text.Top.Menu['LT'].Title[context.language]}
            subtitles={Text.Top.Menu['LT'].Subtitles}
        >
            <Box sx={{ display: { xs: 'none', md: 'inline' }, mb: 2, width: 1 }}>
                <Tabs value={value} onChange={handleChange}>
                    {actions.map((action) => <Tab key={action} icon={<MenuBook />} value={action} label={action} />)}
                </Tabs>
            </Box>
            <Typography variant="h6" sx={{ color: 'primary.main', mb: 2, display: { xs: 'inline', md: 'none' } }}>{value}</Typography>
            <SpeedDial
                ariaLabel="SpeedDial tooltip example"
                sx={{ alignItems: 'end', display: { xs: 'flex', md: 'none' }, position: 'fixed', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon />}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                open={open}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action}
                        FabProps={{
                            sx: {
                                backgroundImage: `linear-gradient(90deg, ${theme.palette.secondary.dark}, ${theme.palette.secondary.light})`,
                                backgroundSize: '200% 200%',
                                justifyContent: 'start',
                                height: 'auto',
                                maxWidth: '300px',
                                padding: '8px 8px',
                                '&:hover': { backgroundColor: 'secondary.light', },
                            },
                            variant: 'extended'
                        }}
                        icon={
                            <Typography
                                style={{
                                    alignItems: 'center',
                                    color: 'black',
                                    display: 'flex',
                                    gap: 8,
                                    textDecoration: 'none',
                                }}
                            >
                                <MenuBook />
                                <span dangerouslySetInnerHTML={{ __html: action }}></span>
                            </Typography>
                        }
                        onClick={() => {
                            setOpen(false);
                            setValue(action);
                        }}
                    />
                ))}
            </SpeedDial>
            {value === 'English Morning Assembly' &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishMorningAssembly_03.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        English teachers, NETs, and TYH students come together on stage to share their insights in a formal setting in our whole-school English morning assemblies. These dynamic assemblies expose students in the audience to a variety of engaging themes presented by the English department, fostering a deeper appreciation for the English language and its diverse topics.
                    </Typography>
                    <Typography color="primary" sx={{ mb: 1 }}>Highlight: World Cup 2026</Typography>
                    <Box sx={{ mb: 2, position: 'relative', width: 1, }}>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishMorningAssemblyWorldCup2026.jpg" hover={true} sx={{ width: 1 }} />
                        <DialogVideo url="https://youtu.be/jdldZcZiV08" />
                    </Box>
                    <Typography sx={{ mb: 1 }}>
                        Experience the excitement of the World Cup 2026 through an unforgettable assembly hosted by four avid football fans. Dressed in vibrant football jerseys, the presenters prepared some special surprises, including a dynamic rap, followed by a spirited group performance of Cristiano Ronaldo's iconic 'SIUUU' celebration! Members of the audience were even invited to participate in a Q&A! The hosts even introduced useful vocabulary in Arabic, Spanish, English, and French, truly making this assembly a celebration of the global tournament.
                    </Typography>
                    <Typography color="primary" sx={{ mb: 1 }}>Highlight: Don't Be Afraid!</Typography>
                    <Box sx={{ mb: 2, position: 'relative', width: 1, }}>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishMorningAssemblyDontBeAfraid.jpg" hover={true} sx={{ width: 1 }} />
                        <DialogVideo url="https://youtu.be/WrAwOnwmHio" />
                    </Box>
                    <Typography sx={{ mb: 1 }}>
                        Catch the highlights of this interactive morning assembly, led by two of our English teachers. Watch until the end for a very special guest appearance!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishMorningAssembly_01.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishMorningAssembly_02.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishMorningAssembly_04.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishMorningAssembly_05.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === 'Halloween' &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/Halloween_04.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        Every October 31st, the school comes alive with excitement as our English teachers don their scariest costumes to give students a thrilling fright! As they roam the halls, students are reminded to say 'Trick or Treat' if they want something sweet; otherwise, they face surprises that are definitely less than sweet! The festive atmosphere is always filled with laughter, chills, and plenty of treats, making it a memorable and spooky Halloween celebration for all!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/Halloween_01.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/Halloween_02.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/Halloween_03.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/Halloween_05.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === 'Themed Activities' &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ThemeActivities_01.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        Hosted by our English Ambassadors, theme activity weeks are always a highlight of the school calendar for the English team. Students participate during lunchtime in games and activities in a fair-like atmosphere. With a relaxed vibe and plenty of chances to win prizes, it's the perfect way to enhance English skills while having fun with friends. In the past, theme activity weeks have featured exciting games like our very own 'TYH Monopoly' and a unique TYH-themed Bingo, where students aim for a full house using teachers' names, school places, and school subjects instead of numbers.
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ThemeActivities_02.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ThemeActivities_03.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ThemeActivities_04.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ThemeActivities_05.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === 'Show and Tell' &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ShowAndTell_03.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        Annually, 3 Show and Tell events are held, each with a special theme, such as Mid-Autumn Festival, Lunar New Year and Celebrating the 25th Anniversary of TYH. Students of all English levels are welcomed and encouraged to give a sharing to their Native English Teachers and fellow students in the English Corner. This cultural experience gives students a taste of performing in front of an audience in a warm, light-hearted and relaxed environment. Often, brave students who 'wow' everyone with their exceptional preparedness and creativity are granted the opportunity to take the stage in morning assembly, showcasing their presentation skills in front of the whole school!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ShowAndTell_01.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ShowAndTell_02.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
        </BoxSubPage >
    );
};
export default EnglishEducation;